const blacklist = [
    "Bar",
    "Casino",
    "Night Club",
    "LGTBIQ",
    "Minibar",
    "Pub",
    "Half Board with Drinks",
    "Full Board with Drinks",
    "All Inclusive with Alcholic Drinks Top Brands",
    "Background Music",
    "Poolside Bar",
    "Swim Up Bar",
    "Rooftop Bar",
    "wine",
    "dancing",
    "lounge",
    "champagin",
    "Swim-up bar",
    "rooftop bar",
    "All Inclusive with Alcholic Drinks own brands",
    "LGTBIQ friendly",
  ];
  
  export function isBlackListed(text : string) {
    if (!text) return false;
  
    const normalizedText = text.toLowerCase();
  
    return blacklist.some((word) =>
      normalizedText.includes(word.toLowerCase())
    );
  }
  